import { useEffect, useState } from 'react'
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../context/AuthContext'
import { ADMIN_DASHBOARD_PATH, adminPath } from '../../../constants/adminRoutes'

const TABS = [
  { route: 'knowledge', labelKey: 'admin.aiAssistant.knowledge' },
  { route: 'analytics', labelKey: 'admin.aiAssistant.analytics' },
]

export function AiAssistantIndexRedirect() {
  const { hasModuleAccess } = useAuth()
  if (!hasModuleAccess('ai_assistant')) {
    return <Navigate to={ADMIN_DASHBOARD_PATH} replace />
  }
  return <Navigate to={adminPath('ai-assistant/knowledge')} replace />
}

export default function AdminAiAssistantLayout() {
  const { t } = useTranslation()
  const { hasModuleAccess } = useAuth()
  const location = useLocation()

  if (!hasModuleAccess('ai_assistant')) {
    return <Navigate to={ADMIN_DASHBOARD_PATH} replace />
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-primary">{t('admin.aiAssistant.title')}</h1>
        <p className="mt-2 text-text/60">{t('admin.aiAssistant.subtitle')}</p>
      </div>
      <div className="mb-6 flex flex-wrap gap-2 border-b border-border pb-3">
        {TABS.map(({ route, labelKey }) => {
          const to = adminPath(`ai-assistant/${route}`)
          const active = location.pathname === to || location.pathname.startsWith(`${to}/`)
          return (
            <Link
              key={route}
              to={to}
              className={`rounded-lg px-3 py-2 text-sm font-medium ${
                active ? 'bg-primary text-white' : 'text-text/70 hover:bg-primary/5 hover:text-primary'
              }`}
            >
              {t(labelKey)}
            </Link>
          )
        })}
      </div>
      <Outlet />
    </div>
  )
}
